export default "__VITE_ASSET__ec2d37b8__"